import { inject } from '@angular/core'
import { ResolveFn } from '@angular/router'
import { OrderStateServiceWrapper } from '../store/state/order/order.state.wrapper.service'
import { Observable, of } from 'rxjs'
import { OrderStateServiceV2 } from '../store/state/order/orderv2/order-state.service'
import { OrderApiResponseStateService } from '../store/state/order/orderv2/order-api-response/order-api-response-state.service'

export const welcomeResolver: ResolveFn<Observable<boolean>> = async () => {
  const orderService = inject(OrderStateServiceWrapper)
  const orderServiceV2 = inject(OrderStateServiceV2)
  const orderApiResponseService = inject(OrderApiResponseStateService)
  orderService.reset();
  orderServiceV2.clearAll();
  orderApiResponseService.clear();
  return of(true)
}